import { ErrorBoundary } from 'react-error-boundary';
import { ErrorInfo } from 'react';
import { ErrorPage } from 'modules/app/components/pages/error-page/ErrorPage';
import { Outlet } from 'react-router-dom';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { TopAppBar } from '../../organisms/top-app-bar/TopAppBar';
import styles from './app-layout.module.scss';

export const AppLayout = () => {
  return (
    <>
      <div className={styles.baseLayout}>
        <ErrorBoundary
          FallbackComponent={ErrorPage}
          onError={(error: Error, info: ErrorInfo) => {
            logger.error({
              message: 'Page Crash',
              object: {
                error,
                info
              },
              includeTrace: true
            });
          }}
        >
          <TopAppBar />
          <div className={styles.content}>
            <Outlet />
          </div>
        </ErrorBoundary>
      </div>
    </>
  );
};
